<template>
  <div class="main">
    <div class="header-card">
      <div class="tabs-box" style="display: flex;justify-content: flex-start;align-items: center">
        <button class="first-btn">搜&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;索：</button>
        <div
            style="display: flex;justify-content: flex-start;align-items: center;border: 1px solid #EB5139;border-right: 0;border-radius: 5px;margin: 0 0 0 12px;">
          <!--          <div>-->
          <!--            <el-select v-model="value" placeholder="请选择" @change="getClass">-->
          <!--              <el-option-->
          <!--                  v-for="item in options"-->
          <!--                  :key="item.value"-->
          <!--                  :label="item.label"-->
          <!--                  :value="item.value">-->
          <!--              </el-option>-->
          <!--            </el-select>-->
          <!--          </div>-->
          <div class="serch" v-if="this.value===0">
            <el-input
                class="study-serch"
                v-model="liveForm.roomName"
                placeholder="请输入课程关键字"
            ></el-input>
            <!--                    <i class="el-icon-search" @click="searchCourse"></i>-->
          </div>
          <!--          <div class="serch" v-if="this.value===1">-->
          <!--            <el-input-->
          <!--                class="study-serch"-->
          <!--                v-model="liveForm.userName"-->
          <!--                placeholder="请输入讲师关键字"-->
          <!--            ></el-input>-->
          <!--            &lt;!&ndash;                    <i class="el-icon-search" @click="searchCourse"></i>&ndash;&gt;-->
          <!--          </div>-->
          <i class="seachI el-icon-search" @click="searchCourse"></i>
        </div>
      </div>
      <div class="tabs-box">
        <button class="first-btn">行业分类：</button>
        <button
            class="o-btn"
            @click="tabsCheck(10,null)"
            :class="{ active: 10 === active }"
        >
          全部
        </button>
        <button
            class="o-btn"
            v-for="(o, index) in ProfessionCateList"
            :key="o.id"
            @click="tabsCheck(index, o.code)"
            :class="{ active: index === active }"
        >
          {{ o.cateName }}
        </button>
      </div>
      <div class="tabs-box">
        <button class="first-btn">专项分类：</button>
        <button
            class="o-btn"
            @click="tabsCheck2(26,null)"
            :class="{ active: 26 === active2 }"
        >
          全部
        </button>
        <button
            v-if="show"
            class="o-btn"
            v-for="(s, index) in specialList.slice(0, 10)"
            :key="s.id"
            @click="tabsCheck2(index, s.id)"
            :class="{ active: index === active2 }"
        >
          {{ s.name }}
        </button>
        <button v-if="show" class="o-btn-more" @click="getMore" style="color: green">
          更多<i style="margin-left: 3px;font-weight: bold" class="el-icon-arrow-down"></i>
        </button>
        <button
            v-if="down"
            class="o-btn"
            v-for="(s, index) in specialList"
            :key="s.id"
            @click="tabsCheck2(index, s.id)"
            :class="{ active2: index === active2 }"
        >
          {{ s.name }}
        </button>
        <button v-if="down" class="o-btn-more" @click="downMore" style="color: green">
          收起<i style="margin-left: 3px;font-weight: bold" class="el-icon-arrow-up"></i>
        </button>
      </div>
      <div class="tabs-box">
        <button class="first-btn">直播状态：</button>
        <button class="o-btn" @click="changeLive(3,null)" :class="{ active: 3 === active4 }">全部</button>
        <button class="o-btn" v-for="(item,index) in liveStatus" :key="item.value"
                @click="changeLive(index,item.value)" :class="{ active: index === active4 }">{{ item.label }}
        </button>
      </div>
      <!--      <div class="tabs-box">-->
      <!--        <button class="first-btn">课程类别：</button>-->
      <!--        <button-->
      <!--            class="o-btn"-->
      <!--            @click="specialtabsCheck3(0)"-->
      <!--            :class="{ active: 0 === active3 }"-->
      <!--        >-->
      <!--          全部-->
      <!--        </button>-->
      <!--        <button-->
      <!--            class="o-btn"-->
      <!--            @click="specialtabsCheck3(1)"-->
      <!--            :class="{ active: 1 === active3 }"-->
      <!--        >-->
      <!--          会员免费-->
      <!--        </button>-->
      <!--      </div>-->
    </div>

    <div class="study-detail">
      <div class="classContent">
        <span style="font-size: 16px">
                    共匹配到
                    <span style="color: #43bc9a">{{ CourseInfo.total }}</span>
                    个课程符合您的筛选条件
                </span>
        <el-empty
            v-if="CourseInfo.records && !CourseInfo.records.length"
            description="暂无数据"
        ></el-empty>
        <div class="cla-detail" v-else>
          <ul class="classItem">
            <li
                v-for="item in CourseInfo.records"
                :key="item.id"
                @click="goCourseDetails(item.id)"
            >
              <div class="times">
                <div>{{ item.B }}</div>
                <div>|</div>
                <div>{{ item.C }}</div>
              </div>
              <div class="imgs" style="margin: 0">
                <img :src="item.roomShowUrl" alt="" class="cla-p"/>
                <p class="public" v-if="item.liveStatus === 0">{{ item.A }}&nbsp;{{ item.B }}开课</p>
                <p class="public" v-if="item.liveStatus === 1">直播中</p>
                <p class="public" v-if="item.liveStatus === 2">直播已结束</p>
              </div>
              <div class="liContent">
                <div class="title" v-html="item.roomName"></div>
                <div class="information">
                  {{ item.description }}
                </div>
                <!--                                <br/>-->
                <div class="times-card">
                  <div class="left">
                    <span>{{ item.industryType }}</span>
                    <span>{{ item.specialId }}</span>
                  </div>
                  <!--                  <div class="right">-->
                  <!--                                        <span><i class="el-icon-view"></i><span-->
                  <!--                                            style="color: #333333;margin: 0 2px 0 5px">{{ item.learnNumber }}</span>学习</span>-->
                  <!--                  </div>-->
                  <!--                  <div class="content">-->
                  <!--                                        <span style="color: #333333;font-weight: bold;"-->
                  <!--                                              v-html=" item.institutionName"></span>-->
                  <!--                  </div>-->
                </div>

              </div>
            </li>
          </ul>
        </div>
        <div class="Pga" v-if="CourseInfo.total > 5">
          <el-pagination
              background
              layout="prev, pager, next, jumper"
              :page-size="5"
              :current-page.sync="currentPage"
              :total="CourseInfo.total"
              @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
      <div class="detail-right">
        <div class="hot-teacher fl">
          <div class="nav_hot">
            <div class="ico_h">
              <i class="icon_t el-icon-trophy"></i>
              <h4 class="title">热门工匠</h4>
            </div>
            <a class="more" href="javascript:;" @click="lecturer">更多 &gt;</a>
          </div>
          <InstructorTemplate/>
        </div>
        <div class="hot-teacher fl">
          <div class="nav_hot">
            <div class="ico_h">
              <i class="icon_t el-icon-notebook-2"></i>
              <h4 class="title">最新会议</h4>
            </div>
            <a class="more" href="javascript:;" @click="goMeetingSearch">更多 &gt;</a>
          </div>
          <ul class="ulContent">
            <li v-for="item in hotMeeting" @click="goDetail(item.id)" :key="item.id">
              {{ item.title }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getHomeProfessionCate} from "@/api/home/home";
import {
  getSpecialList,
} from "@/api/study";
import {getInstitutionCourseInfo} from "@/api/institution/course";
import {latestRelease} from "@/api/meeting";
import {getLiveslist} from "@/api/live";

export default {
  data() {
    return {
      liveForm: {
        current: 1,
        size: 5,
        industryType: null,
        livesteramEndTime: null,
        livesteramTime: null,
        roomName: null,
        roomStatus: null,
        roomType: null,
        roomUuid: null,
        specialId: null,
        userName: null,
        liveStatus: null,
      },
      liveStatus: [
        //     {
        //   value: 0,
        //   label: '未开始'
        // }, {
        //   value: 1,
        //   label: '直播中'
        // },
        {
          value: 2,
          label: '直播回放'
        }],
      institutiolnName: '',
      institutiolnId: 0,
      searchResults: "",
      show: true,
      down: false,
      activeName: "first",
      currentPage: 1,
      ProfessionCateList: [],
      CourseInfo: {},
      active: 10,
      active1: true,
      active2: 26,
      active3: 0,
      active4: 3,
      search: "",
      searchName: "",
      specialList: [],
      getSpecialListAll: {},
      keyword: "",
      industryMapping: {
        "11": "化工医药",
        "12": "电力能源",
        "13": "建筑建材",
        "14": "交通物流",
        "15": "冶金矿山",
        "16": "电子军工",
        "17": "机械机电",
        "18": "轻工环保",
        "19": "信息通信",
      },
      hotMeeting: [],
      options: [{
        value: 0,
        label: '课程'
      },
        //   {
        //   value: 1,
        //   label: '讲师'
        // }
      ],
      value: 0
    };
  },
  methods: {
    // 高亮函数
    highlightKeyword(text, keyword) {
      if (!text || !keyword) return text;
      const regex = new RegExp(`(${this.escapeRegExp(keyword)})`, 'gi');
      return text.replace(regex, '<span style="color:#ff2832;font-weight:bold">$1</span>');
    },

    // 辅助函数（如果不需要访问 `this`，可以移到外部）
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    getClass(e) {
      this.value = e
    },
    goDetail(id) {
      this.$router.push({
        path: `/meetingdetails?id=${id}`,
      });
    },
    goMeetingSearch() {
      this.$router.push({
        path: "/meetingsearch" + this.searchResults,
      });
    },
    lecturer() {
      this.$router.push({
        path: "/consultingexperts",
      });
    },
    getMore() {
      this.show = false
      this.down = true
    },
    downMore() {
      this.show = true
      this.down = false
    },
    handleClick(tab, event) {
      this.liveForm.current = 1;
      this.getCourseData();
    },
    handleCurrentChange(val) {
      this.liveForm.current = val;
      this.getCourseData();
    },
    tabsCheck(index, code) {
      this.active = index;
      this.active1 = false;
      this.liveForm.industryType = code;
      this.liveForm.current = 1;
      this.getCourseData();
    },
    // 选择直播类型
    changeLive(index, id) {
      console.log(index, id)
      this.active4 = index;
      this.liveForm.liveStatus = id;
      this.liveForm.current = 1;
      this.getCourseData();
    },
    // 选择专项
    tabsCheck2(index, id) {
      this.active2 = index;
      this.active1 = false;
      this.liveForm.specialId = id;
      this.liveForm.current = 1;
      this.getCourseData();
    },
    searchCourse() {
      this.getCourseData();
      // if (this.value === 0) {
      //   this.$router.push(`/liveMore?keyword=${this.search}&value=${this.value}`);
      // } else {
      //   this.$router.push(`/liveMore?keyword=${this.searchName}&value=${this.value}`);
      // }
    },
    goCourseDetails(id) {
      this.$router.push("/liveIndex?id=" + id);
    },
    getCourseData() {
      getLiveslist(this.liveForm).then((res) => {
        res.data.records.forEach(item => {
          item.specialId = this.getSpecialListAll[item.specialId]
          if (item.description) {
            // 1. 创建 DOMParser 实例
            const parser = new DOMParser();
            const doc = parser.parseFromString(item.description, 'text/html');
// 2. 提取纯文本
            item.description = doc.body.textContent || doc.body.innerText;
          }
          // 处理时间参数（如果存在直播时间）
          if (item.livesteramTime && item.livesteramEndTime) {
            // 创建日期对象（时间戳是毫秒级）
            const startDate = new Date(item.livesteramTime);
            const endDate = new Date(item.livesteramEndTime);

            // 格式化函数：月:日
            const formatDate = (date) => {
              const month = date.getMonth() + 1; // 月份从0开始
              const day = date.getDate();
              return `${month}月${day}日`;
            };

            // 格式化函数：时:分
            const formatTime = (date) => {
              const hours = date.getHours();
              const minutes = date.getMinutes();
              return `${hours}:${minutes.toString().padStart(2, '0')}`;
            };

            // 设置参数
            item.A = formatDate(startDate); // 月:日
            item.B = formatTime(startDate); // 开始时间（时:分）
            item.C = formatTime(endDate);   // 结束时间（时:分）
          }
          // 高亮关键字（新增逻辑）
          if (this.liveForm.roomName) {
            // 高亮标题中的关键字
            item.roomName = this.highlightKeyword(item.roomName, this.liveForm.roomName);

          }
        })
        this.CourseInfo = res.data;
        // this.CourseInfo = JSON.parse(JSON.stringify(res.data));
        // const {records} = this.CourseInfo;
        // for (let i = 0; i < records.length; i++) {
        //   const {headline, institutionName} = records[i];
        //   records[i].headline = highlightKeyword(headline, this.search);
        //   records[i].institutionName = highlightKeyword(institutionName, this.institutiolnName);
        // }
        //
        // function highlightKeyword(text, keyword) {
        //   return text.replace(
        //       new RegExp(keyword, 'g'),
        //       `<span style="color:#ff2832">${keyword}</span>`
        //   );
        // }
      });
    },

  },

  mounted() {

    // this.active2 = 26
    // this.active = 10
    latestRelease("all").then((res) => {
      if (res.code === 200) {
        this.hotMeeting = res.data
      }
    })
    getHomeProfessionCate().then((res) => {
      if (res.code === 200) {
        this.ProfessionCateList = res.data;
      }
    });
    getSpecialList().then((res) => {
      if (res.code === 200) {
        this.specialList = res.data;
        this.getSpecialListAll = this.specialList.reduce((result, item) => {
          // console.log(result)
          result[item.id] = item.name;
          return result;
        }, {});
        this.getCourseData();
      }
    });
    if (Number(this.$route.query.value) === 1) {
      this.value = 1
      this.searchName = this.institutiolnName = this.$route.query.keyword;
    } else if (Number(this.$route.query.value) === 0) {
      this.value = 0
      this.search = this.keyword = this.$route.query.keyword;
    }
    if (this.$route.query.institutiolnId) {
      this.institutiolnId = this.$route.query.institutiolnId;
    }
  },
};
</script>

<style lang='scss' scoped>
.main {
  margin-bottom: 31px !important;
}

.ulContent {
  padding: 10px 20px 0;
}

.ulContent > li {
  cursor: pointer;
  margin-top: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ulContent > li:hover {
  color: red;
}

.ulContent > li:nth-child(1) {
  margin-top: 0;
}

.serch {
  display: flex;
  width: 188px;
  //border: 1px solid #999999;
  border-radius: 5px;
  overflow: hidden;
  margin: 0;

  .study-serch {
    width: 75%;
    margin: 0;
  }

  i {
    flex: 1;
    text-align: center;
    line-height: 31px;
    background: #eb5139;
    color: #ffffff;
    font-weight: 600;
    font-size: 16px;
    border-radius: 5px;

  }
}

.serchtwo {
  display: flex;
  width: 188px;
  border: 1px solid #999999;
  border-radius: 5px;
  overflow: hidden;
  margin: 0 5px 0 0;

  .study-serch {
    width: 75%;
    margin: 0;
  }

  i {
    flex: 1;
    text-align: center;
    line-height: 31px;
    background: #eb5139;
    color: #ffffff;
    font-weight: 600;
    font-size: 16px;
    border-radius: 5px;

  }

}

.seachI {
  //flex: 1;
  width: 60px;
  text-align: center;
  line-height: 34px;
  background: #eb5139;
  color: #ffffff;
  font-weight: 600;
  font-size: 16px;
  border-radius: 5px;
  margin: 0;
  cursor: pointer;
}

::v-deep .el-input__inner {
  border: none !important;
  border-color: transparent;
}

.o-btn1 {
  padding: 1px 18px;
  margin: 10px 1px;
  cursor: pointer;
}

.active {
  color: white !important;
  background-color: #eb5139 !important;
  border-radius: 5px;
  text-align: center;
}

.active2 {
  color: white !important;
  background-color: #eb5139 !important;
  border-radius: 5px;
  text-align: center;
}

.study-detail {
  position: relative;
  //display: flex;

  overflow: hidden;

}

.classContent {
  width: 64%;
  background-color: white;
  padding: 20px 30px 30px;
  border-radius: 20px;
  float: left;
}

.detail-right {
  width: 28%;
  background-color: white;
  border-radius: 15px;
  float: right;
}

::v-deep .el-tabs__nav-wrap::after {
  height: 0 !important;
}

::v-deep .el-tabs__item.is-active {
  color: #eb5139;
}

::v-deep .el-input--small {
  width: 80px;
}

::v-deep .el-tabs__item {
  width: 72px;
  height: 25px;
  font-size: 18px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  line-height: 21px;
  margin-top: 22px;
  margin-bottom: 5px;
}

::v-deep .el-tabs__active-bar {
  background-color: #eb5139;
  height: 3px;
  margin-left: 10px;
}

.Pga {
  display: flex;
  margin-top: 31px;
}

.main {
  width: 1200px;
  margin: 0 auto;
}

.header-card {
  margin: 20px 0 20px 0;
  //height: 197px;
  padding: 20px 0 45px 0;
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: 0 4px 5px 4px #f1f0f0;
}

.header-left {
  display: inline-block;
  width: 52px;
  height: 22px;
  font-size: 18px;
  margin: 20px 0 0 20px;
  font-weight: bold;
}

.tabs-box {
  position: relative;
  margin-left: 122px;
  margin-top: 25px;
}

.first-btn {
  position: absolute;
  left: -90px;
  width: 85px;
  height: 25px;
  border-radius: 10px 0 10px 10px;
  background-color: white;
  color: #666666;
}

.o-btn {
  width: 7%;
  height: 25px;
  margin-left: 1%;
  background-color: #ffffff;
  font-size: 14px;
  padding: 2px;
  color: #333333;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 3px;
}

.o-btn-more {
  width: 7%;
  height: 22px;
  margin-left: 1%;
  background-color: #ffffff;
  font-size: 14px;
  padding: 2px;
  color: #676c71;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.classItem {
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
}

.classItem > li {
  padding: 15px 20px 20px;
  background-color: #ffffff;
  float: left;
  margin: 0.7% 0.5% !important;
  position: relative;
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid #dddddd;
}

.classItem > li > .liContent {
  height: 100%;
  margin: 0 0 0 15px;
  //flex: 1;
  width: 73%;

}

.classItem > li > .liContent > .information {
  margin: 8px 0 16px 0;
  font-size: 12px;
  line-height: 24px;
  height: 42px;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 显示的行数 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  //font-size: calc(100vw * 14 / 1920);
}

.classItem > li > div > .title {
  //font-size: calc(100vw * 16 / 1920);
  width: 488px;
  font-size: 14px;
  font-weight: bold;
  height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  cursor: pointer;
}


.classItem > li > .imgs {
  background: #ccc;
  height: 102px;
  width: 206px;
  overflow: hidden;
  border-radius: 10px;
  position: relative;
}

.classItem > li > .times {
  margin-right: 15px;
  font-size: 18px;
  text-align: center;
}

.classItem > li > .imgs > img {
  width: 100%;
  height: 100%;
}

.times-card {
  display: flex;
  color: gray;
  justify-content: space-between;
  align-items: center;
  font-size: calc(100vw * 12 / 1920);
  //font-size: 12px;
}

.times-card > .left {
  width: 37%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0;
  color: #ff8916;
  font-size: 11px;
}

.times-card > .left > span {
  padding: 4px 5px;
  background-color: #FEF1DB;
  border-radius: 10px;
  //font-size: 12px;
  margin: 0 10px 0 0;
}

.times-card > .left > span:nth-child(2) {
  margin: 0
}

.right {
  width: 17%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0;

  > span {
    margin: 0;
  }
}

.content {
  width: 40%;
  margin: 0;
}

.public {
  position: absolute;
  top: 0;
  left: 0;
  height: 24px;
  font-size: 11px;
  color: #eee;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 9px 0 10px 0;
  text-align: center;
  line-height: 24px;
  font-weight: 400;
  padding: 0 5px;
}

.o-btn:hover {
  //text-align: left !important;
  color: white !important;
  background-color: #eb5139 !important;
  border-radius: 5px;
  text-align: center;
}

.hot-teacher {
  padding: 10px 20px 20px;
  display: block;
  width: 100%;
  box-sizing: border-box;
}

.nav_hot {
  position: relative;
  width: 100%;
  height: 22px;
  padding-bottom: 12px;
  border-bottom: 1px solid #edf0f5;
  line-height: 22px;
  display: flex;
  justify-content: space-between;
}

.ico_h {
  display: flex;
  color: #eb5139;
  width: 150px;
  margin: 0;
}

.icon_t {
  /* color: #ff3f29; */
  font-size: 30px;
  margin: 0 10px 0 0;
}

.ico_h h4 {
  margin: 0;
  line-height: 30px;
  font-weight: 600;
}

.nav_hot a {
  margin: 0;
}
</style>
